// extracted by mini-css-extract-plugin
export default {"wrapperBg":"Comment_wrapperBg__Tf+DJ","wrapper":"Comment_wrapper__e8awG","title":"Comment_title__AAwxO","textarea":"Comment_textarea__mcOSL","buttons":"Comment_buttons__9wtyR"};